// extracted by mini-css-extract-plugin
export var backdropBlur = "_mh-0";
export var contentCard = "_mh-5";
export var frame = "_mh-2";
export var image = "_mh-4";
export var imagePane = "_mh-3";
export var modal = "_mh-1";